var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: {
          padding: "10px 10px 10px 20px",
          "line-height": "26px",
          color: "#F59A23",
          background: "#D9EDF7",
        },
      },
      [
        _vm._v(
          "注意：:1.“友盟+”运营服务需要的配置参数，需要先去友盟开通相关服务。2.需要打包后生效(打包前非必填)"
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "mt20",
        staticStyle: {
          background: "#fff",
          padding: "30px",
          "border-radius": "20px",
        },
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  rules: _vm.rules,
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "安卓  AppKey", prop: "androidAppKey" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.ruleForm.androidAppKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "androidAppKey", $$v)
                        },
                        expression: "ruleForm.androidAppKey",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "ios  AppKey", prop: "iosAppKey" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.ruleForm.iosAppKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "iosAppKey", $$v)
                        },
                        expression: "ruleForm.iosAppKey",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitForm("ruleForm")
                          },
                        },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c("span", { staticClass: "fc ml20", staticStyle: { color: "red" } }, [
        _vm._v(
          "以下参数设定后请勿随意修改，可能导致友盟无法正常获取平台运营参数!"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }